import { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import SearchBox from '@/components/nav/SearchBox';
import { buildSearchIndex } from '@/utils/articles';
import { SUPPORTED_LANGS, DEFAULT_LANG } from '@/i18n';

/**
 * Visible search trigger sized for the Hero section. Tapping it opens the
 * full SearchBox modal (same Fuse.js index used by the header search icon).
 *
 * Renders as a faux-input with a Search icon on the left and a placeholder
 * teasing some popular queries. On click it opens the modal.
 */
export default function HeroSearchBar({ className = '' }) {
  const { i18n, t } = useTranslation();
  const lang = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : DEFAULT_LANG;
  const [open, setOpen] = useState(false);
  const index = useMemo(() => buildSearchIndex(lang), [lang]);

  const placeholder =
    lang === 'en'
      ? 'Friendly Nations Visa, Tower Bank, Costa del Este...'
      : lang === 'es'
        ? 'Friendly Nations Visa, Tower Bank, Costa del Este...'
        : 'Friendly Nations, Tower Bank, Costa del Este...';

  const label =
    lang === 'en'
      ? 'Search Inside Panama'
      : lang === 'es'
        ? 'Buscar en Inside Panama'
        : 'Rechercher sur Inside Panama';

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={label}
        className={`group flex w-full items-center gap-3 rounded-full border border-navy-900/15 bg-cream-50 px-5 py-3.5 text-left text-gray-700 shadow-sm transition-all hover:border-bordeaux-600/30 hover:bg-cream-100 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-bordeaux-600 focus:ring-offset-2 sm:py-4 ${className}`}
      >
        <Search size={18} aria-hidden="true" className="shrink-0 text-bordeaux-700" />
        <span className="flex-1 truncate text-sm sm:text-base">{placeholder}</span>
        <span className="hidden shrink-0 rounded-btn border border-navy-900/15 bg-cream-50 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-gray-700 group-hover:bg-cream-100 sm:inline-block">
          ⌘K
        </span>
      </button>

      <SearchBox open={open} onClose={() => setOpen(false)} documents={index} />
    </>
  );
}
